import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import Index from '../app/Index/index';
import { fetchIndexSeoRequest } from '../app/Index/actions';
import pageWithReduxAndIntl from '../app/hoc/PageWithReduxAndIntl';
import { dealTypeIdToString } from '../app/utils/dealType';
import { errorSelector, indexSeoSelector } from '~/Index/selectors';

// this is used for ->
// multiple tag requests in the client so it gets more data (the query will change depending of type of 'home')
// avoid multiple consecutive server requests on initial data load
function runSeoRequestSaga(store, query) {
  const dealTypeString = dealTypeIdToString(query.deal_type);
  const propertyType = query.property_type ? decodeURI(query.property_type) : undefined;
  const dataWhereIn = propertyType ? [propertyType, dealTypeString] : [dealTypeString];
  const data = get(indexSeoSelector(store.getState()), dataWhereIn);

  if (!data || data.length === 0) {
    store.dispatch(fetchIndexSeoRequest(query));
  }
}

export class HomesIndex extends React.Component {
  static async getInitialProps({ query, store, isServer, url }) {
    const error = errorSelector(store.getState());
    const statusCode = get(error, ['status'], null);

    runSeoRequestSaga(store, query);

    return { statusCode, isServer, url, query };
  }

  static async runInitialSagas({ store, query }) {
    runSeoRequestSaga(store, query);
  }

  render() {
    const { query, url } = this.props;

    return <Index query={query} url={url} />;
  }
}

HomesIndex.propTypes = {
  query: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
};

export default pageWithReduxAndIntl(HomesIndex);



// WEBPACK FOOTER //
// ./pages/index.js